<template>
    <div class="context">
        <component :is="component_id"
                   @changeTopTab="switchModule"
                   :ref="component_id"></component>
    </div>
</template>

<script>
    import levelView from "./level"
    import ruleView from "./rule"
    import setupView from "./setting"
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "",
        components: {
            levelView,
            ruleView,
            setupView
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapState('comInformationData', {
                component_id: 'component_id'
            })
        },
        methods: {
            switchModule(id) {

            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>